import { gql } from "@apollo/client";

export const SAVE_RESPUESTA = gql`
    mutation SaveJustificacionIndicacionAprobacion($input: IndicacionAprobacionJustificacionInput!) {
    saveJustificacionIndicacionAprobacion(input: $input) {
      success,
      error,
      valorEsperado
    }
  }
`;